import React, { useEffect, useState } from 'react'
import {
  Col,
  Input,
  Row,
  FormGroup,
  Button,
  ButtonGroup,
  Alert,
} from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Select from 'react-select'
import Switch from 'react-switch'
import { productTypeOptions, packageTypeOptions } from './constants'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'

const InfantFruitsAndVegsPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    PackageType: item.PackageType,
    PacketSize: item.PacketSize,
    NoAdditionalIngredients: item.NoAdditionalIngredients,
    Organic: item.Organic,
    MultiPackageType: item.MultiPackageType,
    MultiPackageCount: item.MultiPackageCount,
    ProductType: item.ProductType,
  })
  const methods = useFormContext()
  const {
    setSelectReviewer,
    setSwitchReviewer,
    onChangeReviewer,
    asterisk,
  } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const {
        fkSubCategory,
        PackageType,
        PacketSize,
        NoAdditionalIngredients,
        Organic,
        MultiPackageType,
        MultiPackageCount,
        ProductType,
      } = item
      setPackaging({
        fkSubCategory,
        PackageType,
        PacketSize,
        NoAdditionalIngredients,
        Organic,
        MultiPackageType,
        MultiPackageCount,
        ProductType,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <>
      <Row>
        <Col xs={4}>
          <p>
            <strong>Product Type {asterisk}</strong>
          </p>
          <ButtonGroup>
            <Button
              outline
              color="success"
              className="btn-round"
              active={
                ['001', '101'].includes(packaging.fkSubCategory) && !isDisabled
              }
              disabled={isDisabled}
              onClick={() => {
                if (packaging.Organic === true) {
                  setPackaging({ ...packaging, fkSubCategory: '101' })
                  item.fkSubCategory = '101'
                } else {
                  setPackaging({ ...packaging, fkSubCategory: '001' })
                  item.fkSubCategory = '001'
                }
              }}
              size="sm"
            >
              {productTypeOptions[0]}
            </Button>
          </ButtonGroup>
          <ButtonGroup>
            <Button
              outline
              color="success"
              className="btn-round"
              active={
                ['002', '102'].includes(packaging.fkSubCategory) && !isDisabled
              }
              disabled={isDisabled}
              onClick={() => {
                if (packaging.Organic === true) {
                  setPackaging({ ...packaging, fkSubCategory: '102' })
                  item.fkSubCategory = '102'
                } else {
                  setPackaging({ ...packaging, fkSubCategory: '002' })
                  item.fkSubCategory = '002'
                }
              }}
              size="sm"
            >
              {productTypeOptions[1]}
            </Button>
          </ButtonGroup>
          <ButtonGroup>
            <Button
              outline
              color="success"
              className="btn-round"
              active={
                ['003', '103'].includes(packaging.fkSubCategory) && !isDisabled
              }
              disabled={isDisabled}
              onClick={() => {
                if (packaging.Organic === true) {
                  setPackaging({ ...packaging, fkSubCategory: '103' })
                  item.fkSubCategory = '103'
                } else {
                  setPackaging({ ...packaging, fkSubCategory: '003' })
                  item.fkSubCategory = '003'
                }
              }}
              size="sm"
            >
              {productTypeOptions[2]}
            </Button>
          </ButtonGroup>
          <br />
          <br />
          <FormGroup>
            <p>
              <strong>Size {asterisk}</strong>
            </p>
          </FormGroup>
          <Input value={packaging.PacketSize} disabled />
        </Col>
        <Col xs={4}>
          <p>
            <strong>Package Type {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={packageTypeOptions}
            defaultValue={{
              label: packaging.PackageType,
              value: packaging.PackageType,
            }}
            name="PackageType"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Package Type'}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              return selected
            }}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="PackageType"
              message={'⚠ This selection is required.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
          <br />
          <p>
            <strong>Multi-pack</strong>
          </p>
          <Controller
            as={Switch}
            name="MultiPackageType"
            id="MultiPackageType"
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              setPackaging({ ...packaging, MultiPackageType: checked })
              return checked
            }}
            control={methods.control}
            defaultValue={packaging.MultiPackageType}
            disabled={isDisabled}
          />
          <br />
          <br />
          <br />
          {packaging.MultiPackageType && (
            <FormGroup>
              <p>
                <strong>Multi-pack Count {asterisk}</strong>
              </p>
              <Controller
                as={Input}
                name="MultiPackageCount"
                placeholder={'Multi-pack Count'}
                defaultValue={packaging.MultiPackageCount}
                onKeyDown={e => {
                  if (
                    ![
                      'Backspace',
                      'Delete',
                      'Tab',
                      'ArrowLeft',
                      'ArrowRight',
                    ].includes(e.key) &&
                    isNaN(parseInt(e.key))
                  ) {
                    e.preventDefault()
                  }
                }}
                control={methods.control}
                rules={{
                  maxLength: { value: 2, message: '⚠ 2 characters max.' },
                  required: {
                    value: true,
                    message: '⚠ Multi Pack Count is required.',
                  },
                  validate: MultiPackageCount => MultiPackageCount > 0,
                }}
                onChange={([event]) => {
                  onChangeReviewer(item, event)
                  return event
                }}
                disabled={isDisabled}
              />
              <p className={'text-danger'}>
                <ErrorMessage
                  errors={methods.errors}
                  name="MultiPackageCount"
                  message={'⚠ Multi Pack Count must be greater than 0.'}
                  as={<Alert color={'danger'} className={'mt-3'} />}
                />
              </p>
            </FormGroup>
          )}
        </Col>
        <Col xs={4}>
          <p>
            <strong>Organic</strong>
          </p>
          <Controller
            as={Switch}
            name="Organic"
            id="Organic"
            defaultValue={packaging.Organic}
            onChange={([checked, event, id]) => {
              switch (item.fkSubCategory) {
                case '001':
                case '101':
                  setSwitchReviewer(item, checked, event, id, '101', '001')
                  break
                case '002':
                case '102':
                  setSwitchReviewer(item, checked, event, id, '102', '002')
                  break
                case '003':
                case '103':
                  setSwitchReviewer(item, checked, event, id, '103', '003')
                  break
                default:
                  break
              }
              setPackaging({ ...packaging, Organic: checked })
              return checked
            }}
            control={methods.control}
            disabled={isDisabled}
          />
          <br />
          <hr />
          <p>
            <strong>
              I certify that this product does not contain added sugar, salt,
              starch, or spice. {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="NoAdditionalIngredients"
            id="NoAdditionalIngredients"
            defaultValue={packaging.NoAdditionalIngredients}
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              return checked
            }}
            control={methods.control}
            rules={{
              validate: NoAdditionalIngredients =>
                NoAdditionalIngredients === true,
            }}
            disabled={isDisabled}
          />
          <br />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="NoAdditionalIngredients"
              message={
                '⚠ Product must not contain added sugar, salt, starch, or spice.'
              }
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </Col>
      </Row>
    </>
  )
}

InfantFruitsAndVegsPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default InfantFruitsAndVegsPackageReview
